import React, { Component, PropTypes } from 'react';

class ReactSparkTextArea extends Component {
    render() {
        return (
            <div>
                <label className="spark-input" ref={node => (this.textInputMount = node)} data-characters-remaining>
                    <textarea
                        className="spark-input__field"
                        role="textbox"
                        name={this.props.name}
                        placeholder={this.props.placeholder}
                        data-maxlength-soft={this.props.softMaxLength}
                    />
                    <span className="spark-label">{this.props.label}</span>
                </label>
            </div>
        );
    }
}

ReactSparkTextArea.propTypes = {
    name: PropTypes.string,
    placeholder: PropTypes.string,
    softMaxLength: PropTypes.number,
    label: PropTypes.string
};

export default ReactSparkTextArea;



// WEBPACK FOOTER //
// ./src/components/widgets/ReactSparkTextArea.js